import { Close } from '@material-ui/icons';
import styles from './Chip.module.scss';

type PropsType = {
  label: string;
  onClick?: () => void;
  onDelete?: () => void;
  color?: 'black' | 'white' | 'white_blue';
  lowerCase?: boolean;
};

const ChipMain = ({
  label,
  onClick,
  onDelete,
  color = 'white',
  lowerCase
}: PropsType) => {
  const chipClassName = (() => {
    switch (color) {
      case 'black':
        return styles.chip_black;
      case 'white_blue':
        return styles.chip_white_blue;
      case 'white':
      default:
        return styles.chip_white;
    }
  })();

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  };

  return (
    <div
      className={chipClassName}
      style={{
        paddingRight: onDelete ? '8px' : '16px',
        textOverflow: "ellipsis",
      }}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label={label}
    >
      <span style={{ textTransform: lowerCase ? "lowercase" : "none" }}>{label}</span>
      {onDelete && (
        <div onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
          className={styles.icon_box}
          aria-label="Delete"
          role="button"
          tabIndex={-1}>
          <Close />
        </div>
      )}
    </div>
  );
};

export default ChipMain;
